import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { SiteProvider } from "@/context/SiteContext";
import Landing from "@/pages/Landing";
import AboutUsPage from "@/pages/AboutUs";
import ApplyNowPage from "@/pages/ApplyNow";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import PromoPopup from "@/components/site/PromoPopup";

function SiteChrome({ children }) {
  return (
    <>
      {children}
      <PromoPopup />
    </>
  );
}

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(err) {
    console.error(err);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-[#0A0F2C] text-white font-display text-lg px-6 text-center">
          Something went wrong. Please refresh the page.
        </div>
      );
    }
    return this.props.children;
  }
}

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <ScrollToTop />
        <SiteProvider>
          <Routes>
            <Route path="/" element={<SiteChrome><Landing /></SiteChrome>} />
            <Route path="/about" element={<SiteChrome><AboutUsPage /></SiteChrome>} />
            <Route path="/apply" element={<SiteChrome><ApplyNowPage /></SiteChrome>} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
          </Routes>
        </SiteProvider>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
